import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ArticulacionAcademicaPertinenciaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ArticulacionAcademicaPertinenciaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getArticulacionAcademicaPertinenciaService(): Observable<
    BodyListResponse<ArticulacionAcademicaPertinenciaDTO>
  > {
    return this.http.get<BodyListResponse<ArticulacionAcademicaPertinenciaDTO>>(
      API_URL + '/api/v1/articulacionAcademicaPertinencia/todos',
    );
  }

  guardarArticulacionAcademicaPertinenciaService(
    articulacionAcademicaPertinenciaDTO: ArticulacionAcademicaPertinenciaDTO,
  ): Observable<BodyResponse<ArticulacionAcademicaPertinenciaDTO>> {
    return this.http.post<BodyResponse<ArticulacionAcademicaPertinenciaDTO>>(
      API_URL + '/api/v1/articulacionAcademicaPertinencia',
      articulacionAcademicaPertinenciaDTO,
    );
  }

  getArticulacionAcademicaPertinenciaPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ArticulacionAcademicaPertinenciaDTO>> {
    return this.http.get<BodyResponse<ArticulacionAcademicaPertinenciaDTO>>(
      API_URL + '/api/v1/articulacionAcademicaPertinencia/' + codigo,
    );
  }

  getArticulacionAcademicaPertinenciaPorProyectoService(
    codigoProyecto: string,
  ): Observable<BodyListResponse<ArticulacionAcademicaPertinenciaDTO>> {
    return this.http.get<BodyListResponse<ArticulacionAcademicaPertinenciaDTO>>(
      API_URL +
        '/api/v1/articulacionAcademicaPertinencia/proyecto/' +
        codigoProyecto,
    );
  }
}
